export default __webpack_public_path__ + "static/media/trustCheckDark.5b7651c1.svg";